import { FunctionComponent } from "react";
import { FieldOptionInterface } from "models/list-entity-field";
import FieldOptionForm from "./field-option-form";
import Modal from "components/layout/modal";

interface EditFieldOptionModalProps {
  options: FieldOptionInterface[];
  option: FieldOptionInterface;
  onUpdate: (option: FieldOptionInterface) => Promise<void>;
  onClose: () => Promise<void>;
}

const AddFieldOptionModal: FunctionComponent<EditFieldOptionModalProps> = ({
  option,
  options,
  onUpdate,
  onClose,
}) => {
  const onSubmit = async (values: any) => {
    onUpdate(values);
    onClose();
  };

  return (
    <Modal title="Muokkaa vaihtoehtoa">
      <FieldOptionForm
        option={option}
        // remove identifier of the current field
        existingValues={options
          .map((o) => o.value)
          .filter((e) => e !== option.value)}
        onSubmit={onSubmit}
        onClose={onClose}
      />
    </Modal>
  );
};

export default AddFieldOptionModal;
